import React from 'react';
import { Card, CardBody, CardTitle, Progress } from 'reactstrap';

// Medicine sales type
interface MedicineSale {
  name: string;
  dosage: string;
  totalSold: number;
  progress: {
    value: number;
    color: string;
  };
}

// Static mock data for top-selling medicines
const topSellingMedicines: MedicineSale[] = [
  {
    name: 'Paracetamol',
    dosage: '500mg',
    totalSold: 1456,
    progress: { value: 72, color: 'primary' },
  },
  {
    name: 'Amoxicillin',
    dosage: '250mg',
    totalSold: 1123,
    progress: { value: 65, color: 'success' },
  },
  {
    name: 'Ibuprofen',
    dosage: '400mg',
    totalSold: 987,
    progress: { value: 58, color: 'info' },
  },
];

const TopSellingMedicines: React.FC = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Top Selling Medicines</CardTitle>

        <div className="text-center">
          <div className="mb-3">
            <i className="bx bx-capsule text-primary display-4" />
          </div>
          <h3>{topSellingMedicines[0].totalSold}</h3>
          <p className="mb-1">
            <strong>{topSellingMedicines[0].name}</strong> ({topSellingMedicines[0].dosage})
          </p>
          <small className="text-muted">Highest selling medicine this week</small>
        </div>

        <div className="table-responsive mt-4">
          <table className="table align-middle table-nowrap mb-0">
            <thead>
              <tr>
                <th>Medicine</th>
                <th>Units Sold</th>
                <th style={{ width: '40%' }}>Sales %</th>
              </tr>
            </thead>
            <tbody>
              {topSellingMedicines.map((med, index) => (
                <tr key={index}>
                  <td>
                    <p className="mb-0 fw-semibold">
                      {med.name} <small className="text-muted">({med.dosage})</small>
                    </p>
                  </td>
                  <td>
                    <h6 className="mb-0">{med.totalSold.toLocaleString()}</h6>
                  </td>
                  <td>
                    <Progress
                      value={med.progress.value}
                      color={med.progress.color}
                      className="progress-sm"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );
};

export default TopSellingMedicines;
